<template>
  <ag-form
    ref="form"
    :submit-label="submitLabel"
    :submit-loading="loading"
    :hide-controls="hasNoChanges"
    @submit="$emit('input', internalValue)"
    @cancel="restoreInternalValue"
  >
    <v-text-field
      v-model="internalValue.userLogin"
      :rules="$options.rules.userLogin"
      :error-messages="userLoginErrorMessage"
      :label="$t('user.login')"
      prepend-icon="mdi-account"
      type="text"
    />

    <roles-field
      v-model="internalValue.roles"
      :disabled="disabledRoles"
    />

    <v-text-field
      v-model="internalValue.firstName"
      :rules="$options.rules.firstName"
      :label="$t('user.firstName')"
      prepend-icon="mdi-account-details"
      type="text"
    />

    <v-text-field
      v-model="internalValue.lastName"
      :rules="$options.rules.lastName"
      :label="$t('user.lastName')"
      prepend-icon="mdi-account-details"
      type="text"
    />

    <v-text-field
      v-if="hasEmail"
      v-model="internalValue.email"
      :rules="$options.rules.email"
      :label="$t('user.email')"
      prepend-icon="mdi-email"
      type="mail"
    />

    <ag-password-field
      v-model="internalValue.password"
      :password-label="$t('user.changePassword')"
      :confirm-label="$t('user.confirmPassword')"
      optional
    />

    <ag-language-field
      v-model="internalValue.lang"
      :label="$t('general.language')"
    />
  </ag-form>
</template>

<script>
import _isEqual from 'lodash/isEqual'

import AgForm from 'src/components/common/AgForm'
import AgPasswordField from 'src/components/common/AgPasswordField'
import AgLanguageField from 'src/components/common/AgLanguageField'
import RolesField from 'src/components/field/RolesField'
import FormRules from 'src/utils/form-rules'
import Helpers from 'src/utils/helpers'

export default {
  name: 'CurrentUserForm',
  components: {
    AgForm,
    AgPasswordField,
    AgLanguageField,
    RolesField,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        userLogin: '',
        firstName: '',
        lastName: '',
        roles: [],
        lang: '',
        password: '',
      }),
    },
    submitLabel: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    forbiddenUserList: {
      type: Array,
      default: () => ([]),
    },
    disabledRoles: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    internalValue: {},
    confirmPassword: '',
  }),
  computed: {
    userLoginErrorMessage () {
      return this.forbiddenUserList.includes(this.internalValue.userLogin)
        ? this.$t('error.form.userExist')
        : null
    },
    hasEmail () {
      return this.internalValue.roles.includes('ADMIN')
        || this.internalValue.roles.includes('OWNER')
    },
    hasNoChanges () {
      return _isEqual(this.value, this.internalValue)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.restoreInternalValue()
      },
    },
  },
  methods: {
    restoreInternalValue () {
      this.internalValue = Helpers.clone(this.value)
    },
  },
  rules: {
    userLogin: [
      FormRules.required('error.form.required'),
      FormRules.maxLength('error.form.maxLength', { length: 15 }),
      FormRules.minLength('error.form.minLength', { length: 2 }),
      FormRules.noSpaces('error.form.noSpaces'),
    ],
    firstName: [
      FormRules.required('error.form.required'),
    ],
    lastName: [
      FormRules.required('error.form.required'),
    ],
    email: [
      FormRules.required('error.form.required'),
      FormRules.email('error.form.email'),
    ],
  },
}
</script>
